import LegalLayout from "@/components/LegalLayout";
import { useLanguage } from "@/App";

/**
 * /delete-account — Account & Data Deletion Request page.
 * Public (no auth required) so Google Play / App Store reviewers can reach it.
 * Mirrors the bilingual structure used by Terms/Privacy/Refund/Disclaimer.
 */
export default function DeleteAccount() {
  const { language } = useLanguage();
  const ar = language === "ar";
  return (
    <LegalLayout titleAr="حذف الحساب وطلب حذف البيانات" titleEn="Delete Account and Data Deletion Request">
      <section>
        <p>{ar
          ? "يستطيع المستخدمون طلب حذف حسابهم في Arab Sanad وجميع البيانات الشخصية المرتبطة به عن طريق التواصل معنا على:"
          : "Users can request deletion of their Arab Sanad account and associated personal data by contacting us at:"}</p>
        <p className="text-yellow-400 font-bold text-base">
          <a href="mailto:privacy@arabsanad.com" className="hover:underline" data-testid="privacy-email-link">
            privacy@arabsanad.com
          </a>
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">
          {ar ? "البيانات التي قد يتم حذفها" : "Data that may be deleted"}
        </h2>
        <ul className="list-disc pr-6 space-y-1">
          <li>{ar ? "الاسم" : "Name"}</li>
          <li>{ar ? "البريد الإلكتروني" : "Email address"}</li>
          <li>{ar ? "رقم الهاتف" : "Phone number"}</li>
          <li>{ar ? "بيانات الملف الشخصي" : "Profile information"}</li>
          <li>{ar ? "الرسائل" : "Messages"}</li>
          <li>{ar ? "الصور والفيديوهات وأي محتوى رفعه المستخدم" : "Uploaded photos, videos, and user-generated content"}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">
          {ar ? "مدة معالجة الطلب" : "Processing time"}
        </h2>
        <p>{ar
          ? "تتم معالجة طلبات الحذف خلال 30 يوماً."
          : "Deletion requests are processed within 30 days."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">
          {ar ? "بيانات الدفع" : "Payment data"}
        </h2>
        <p>{ar
          ? "لا تخزّن Arab Sanad بيانات بطاقات الائتمان الكاملة. تتم معالجة جميع المدفوعات بشكل آمن عبر Stripe."
          : "Arab Sanad does not store full credit card details. Payments are processed securely by Stripe."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">
          {ar ? "السجلات التي قد يتم الاحتفاظ بها" : "Records that may be retained"}
        </h2>
        <p>{ar
          ? "قد يتم الاحتفاظ ببعض سجلات المعاملات المالية والفواتير وسجلات الدفع لمدة 5–7 سنوات عندما يكون ذلك مطلوباً لأغراض قانونية أو ضريبية أو محاسبية أو لمنع الاحتيال أو للامتثال للوائح المعمول بها."
          : "Some financial transaction records, invoices, and payment records may be retained for 5–7 years when required for legal, tax, accounting, fraud prevention, or compliance purposes."}</p>
      </section>

      <section>
        <p className="text-slate-400 text-xs">
          {ar ? "آخر تحديث: فبراير 2026." : "Last updated: February 2026."}
        </p>
      </section>
    </LegalLayout>
  );
}
